import { Component, ViewChild, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { SlickGridOptions, SlickGridColumnModel, SlickGridComponent, SlickContextMenuComponent, SlickGridColumnFilterTypes, SlickScreenBlockerService, SlickToastService, SlickConfirmDialogComponent, SlickConfirmDialogResults, SlickDialogComponent } from "@slick-components";
import { GlobalsService, AuthService, FunctionLockService, InvoicesService, LookupService, UtilsService, PaymentProcessorService } from '@services';
import { HttpHeaders } from '@angular/common/http';
import { IInvoiceGridModel, IInvoiceModel, InvoiceModel, IDropdownModel, DropdownModel } from '@models';
import { AccountingStore } from "@stores";
import * as moment from "moment";
import { EmailerDialogComponent } from "@components/emailer-dialog";
import { BatchPaymentDialogComponent } from "@shared-components/batch-payment-dialog"
import { stat } from 'fs';


@Component({
    selector: 'invoices-grid',
    templateUrl: './invoices-grid.component.html',
    providers: [InvoicesService, SlickScreenBlockerService, PaymentProcessorService]
})
export class InvoicesGridComponent implements OnInit {
    @Input() autoSelectFirstRow: boolean = false;
    @Input() customerId?: number;
    @Input() hideFilters: boolean = false;
    @Input() hideNewButton: boolean = false;

    @Output() onInvoiceSelected = new EventEmitter<IInvoiceModel>();

    @ViewChild('invoicesGrid', { static: true }) invoicesGrid: SlickGridComponent;
    @ViewChild('invoicesGridContextMenuRef', { static: true }) invoicesGridContextMenuRef: SlickContextMenuComponent;
    @ViewChild("deleteInvoiceConfirmRef", { static: true }) deleteInvoiceConfirmRef: SlickConfirmDialogComponent;
    @ViewChild("emailerDialogRef") emailerDialogRef: EmailerDialogComponent;
    @ViewChild("batchPaymentDialogRef") batchPaymentDialogRef: BatchPaymentDialogComponent;
    @ViewChild("invoiceStatusSelector") invoiceStatusSelector: SlickConfirmDialogComponent;

    batchInvoiceStatusId: number;

    gridOptions = new SlickGridOptions();
    selectedInvoice: IInvoiceModel;

    searchText: string = "";
    lastSearchString;
    searchTimeout: NodeJS.Timer;
    isJellyfish: boolean = (GlobalsService.company.companyId === 133);
    showDealersOnly: boolean = (localStorage.getItem("INVOICE_SHOW_DEALERS_ONLY") || 'false').toLowerCase() === 'true';
    showInternalSales: boolean = (localStorage.getItem("INVOICE_SHOW_INTERNAL_SALES") || 'false').toLowerCase() === 'true';
    showInactiveOnly: boolean = ((localStorage.getItem("INVOICES_SHOW_INACTIVE_ONLY") || 'false') === 'true');

    invoiceStatuses: IDropdownModel[] = [];
    batchInvoiceStatuses: IDropdownModel[] = [];

    salesReps: IDropdownModel[] = [];
    selectedSalesRepUserId: number = null;

    arReps: IDropdownModel[] = [];
    selectedArRepId: number = null;

    batchItems = [new DropdownModel(1, "Email"),
    new DropdownModel(2, "Print"),
    new DropdownModel(4, "Delete"),
    new DropdownModel(5, "Change Status")];

    invoiceMonths = [
    new DropdownModel(1, "Past 1 Month"),
    new DropdownModel(3, "Past 3 Months"),
    new DropdownModel(6, "Past 6 Months"),
    new DropdownModel(12, "Past 12 Months"),
    new DropdownModel(24, "Past 24 Months"),
    new DropdownModel(0, "All Time")
    ];
    batchActionId: number;
    isSubmitted: boolean;
    gridModelsForBatch: IInvoiceGridModel[] = [];

    selectedInvoiceStatus = parseInt(localStorage.getItem("SELECTED_INVOICE_STATUS") || '5');
    selectedInvoiceMonths = parseInt(localStorage.getItem("SELECTED_INVOICE_MONTHS") || '3');
    isQuickbooksEnabled = GlobalsService.isQuickbooksEnabled;
    showNotSyncedToQuickbooks: boolean = ((localStorage.getItem("INVOICES_SHOW_NOT_SYNCED_TO_QUICKBOOKS") || 'false') === 'true');
    isBusinessCentralEnabled = GlobalsService.isBusinessCentralEnabled;
    showNotSyncedToBusinessCentral: boolean = ((localStorage.getItem("INVOICES_SHOW_NOT_SYNCED_TO_BUSINESS_CENTRAL") || 'false') === 'true');
    showInvoicesWhereJobIsComplete: boolean = ((localStorage.getItem("INVOICES_SHOW_INVOICES_WHERE_JOB_IS_COMPLETE") || 'false') === 'true');
    showInvoicesWhereOrderHasShipped: boolean = ((localStorage.getItem("INVOICES_SHOW_INVOICES_WHERE_ORDER_HAS_SHIPPED") || 'false') === 'true');
    showPOSOnly: boolean = ((localStorage.getItem("INVOICES_SHOW_POS_ONLY") || 'false') === 'true');
    useLathamOrdering = GlobalsService.company.useLathamOrdering;
    filteredLocationIds: number[] = null;

    private contextMenuData: any;

    constructor(
        private authService: AuthService,
        private functionLockService: FunctionLockService,
        lookupService: LookupService,
        private slickScreenBlockerService: SlickScreenBlockerService,
        private slickToastService: SlickToastService,
        private invoicesService: InvoicesService,
        private accountingStore: AccountingStore) {

        if (GlobalsService.company.useLathamOrdering === false)
            this.showInvoicesWhereOrderHasShipped = false;

        this.invoiceStatuses = lookupService.getInvoiceStatusesForDropdown();
        this.salesReps = lookupService.getUsers().filter(x => x.isSalesRep).map(x => new DropdownModel(x.userId, x.fullName));
        this.arReps = lookupService.getUsers().filter(x => x.isAR === true).map(x => new DropdownModel(x.userId, x.fullName));
        // we need to get rid of open/closed status because we cannot assign that to an invoice
        this.batchInvoiceStatuses = this.invoiceStatuses.filter(x => x.id !== 5 && x.text !== 'All Invoices');
        this.gridOptions.gridKey = 'Invoices';
        this.gridOptions.striped = false;
        this.gridOptions.bordered = false;
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "BATCH_CHECKBOX", title: '', dataFieldName: 'batch', default: true }))

        if (GlobalsService.isQuickbooksEnabled)
            this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "QUICKBOOKS_SYNC", title: 'QB', dataFieldName: 'quickbooksSyncStatus', default: true }));
        if (GlobalsService.isBusinessCentralEnabled)
            this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "BUSINESS_CENTRAL_SYNC", title: 'BC', dataFieldName: 'businessCentralSyncStatus', default: true }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Invoice #', dataFieldName: 'invoiceNumber', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'PO #', dataFieldName: 'purchaseOrderNumber', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        // If this is jellyfish, add this column as a default.  Everyone else gets it as optional
        if (GlobalsService.company.companyId === 133) {
            this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "ACCEPTED_DATE", title: 'Accepted Date', dataFieldName: 'acceptedDate', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        }
        else {
            this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "ACCEPTED_DATE", title: 'Accepted Date', dataFieldName: 'acceptedDate', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        }
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Customer', dataFieldName: 'displayName', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'First Name', dataFieldName: 'firstName', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Last Name', dataFieldName: 'lastName', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Full Name', dataFieldName: 'fullName', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Company', dataFieldName: 'companyName', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Address1', dataFieldName: 'address1', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Address2', dataFieldName: 'address2', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'City', dataFieldName: 'city', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'State', dataFieldName: 'state', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Zipcode', dataFieldName: 'zipcode', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Country', dataFieldName: 'country', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "INVOICE_DATE", title: 'Invoice Date', dataFieldName: 'invoiceDate', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "INVOICE_DUE_DATE", title: 'Due Date', dataFieldName: 'invoiceDueDate', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Days Past Due', dataFieldName: 'daysPastDue', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Total', dataFieldName: 'invoiceTotalDisplay', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Payments', dataFieldName: 'appliedPaymentsTotalDisplay', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Due', dataFieldName: 'outstandingBalanceDisplay', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
        this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "SALES_REP", title: 'Sales Rep', dataFieldName: 'salesRepUserId', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));

        this.gridOptions.getUrl = GlobalsService.apiUrl + '/invoices/getInvoicesForGridView';
        this.gridOptions.httpHeaders = new HttpHeaders()
            .append('Authorization', `Bearer ${this.authService.getToken()}`)
            .append("TimeZoneOffset", (moment().utcOffset() / 60).toString());
    }

    async ngOnInit() {
        if (GlobalsService.company.useCreditCardProcessor)
            this.batchItems.splice(2, 0, new DropdownModel(3, "Payment"))

        this.searchText = this.accountingStore.searchText;
        this.gridOptions.autoSelectFirstRow = this.autoSelectFirstRow;
        // The first time, let the onLocationsChanged refresh since we don't know what locations are selected
        //this.updateGrid();
    }

    async onShowInactiveOnlyClicked() {
        this.showInactiveOnly = !this.showInactiveOnly;
        localStorage.setItem("INVOICES_SHOW_INACTIVE_ONLY", this.showInactiveOnly.toString().toLowerCase());

        await this.updateGrid();
    }

    async onBatchClicked(gridModel: IInvoiceGridModel, e: Event) {
        e.stopPropagation();

        this.gridModelsForBatch = this.gridModelsForBatch.filter(x => x.invoiceId !== gridModel.invoiceId);
        gridModel.batch = !gridModel.batch;
        if (gridModel.batch)
            this.gridModelsForBatch.push(gridModel);
    }

    async performBatch() {
        this.isSubmitted = true;
        if (!this.batchActionId)
            return;
        let batchInvoiceIds = [];
        // no need to push the ids here for emailing because we will do that in the case 1 below
        if (this.batchActionId !== 1)
            this.gridModelsForBatch.forEach(x => {
                batchInvoiceIds.push(x.invoiceId);
            });
        switch (this.batchActionId) {
            case 1:
                let groupedInvoices = {};
                this.gridModelsForBatch.forEach(x => {
                    if (!groupedInvoices[x.customerId]) {
                        groupedInvoices[x.customerId] = [];
                    }
                    groupedInvoices[x.customerId].push(x.invoiceId);
                });

                for (const customerId of Object.keys(groupedInvoices)) {
                    this.slickScreenBlockerService.block();

                    try {
                        let batchUuid = UtilsService.newGuid();

                        const emailerModel = await this.invoicesService.prepareBatchInvoiceEmail(groupedInvoices[customerId], batchUuid);
                        this.slickScreenBlockerService.unblock();

                        let emailed = await this.emailerDialogRef.showDialog(emailerModel);
                        if (emailed) {
                            groupedInvoices[customerId].forEach(x => this.invoicesService.addInvoiceEmailSentNote(x, true));
                        }
                    } catch (error) {
                        console.error("Error processing customer ID:", customerId, error);
                        this.slickScreenBlockerService.unblock();
                    }

                }
                break;
            case 2:
                let batchEstimateUuid = UtilsService.newGuid();
                const w = window.open('', '_blank');
                w.document.write('Generating pdf...');
                const batchInvoiceUrl = await this.invoicesService.printBatchInvoices(batchInvoiceIds, batchEstimateUuid);
                w.location.href = batchInvoiceUrl;
                break;
            case 3:
                let processedPayments = await this.batchPaymentDialogRef.showDialog(this.gridModelsForBatch);
                this.gridModelsForBatch.forEach(x => {
                    processedPayments.forEach(pp => {
                        if (pp.invoiceGridModels.includes(x)) {
                            x.batch = false;
                            this.gridModelsForBatch = this.gridModelsForBatch.filter(gm => gm !== x);
                        }
                    })
                })
                this.updateGrid();

                break;
            case 4:
                batchInvoiceIds.forEach(async x => {
                    await this.invoicesService.deleteInvoice(x);
                })
                this.updateGrid();
                this.slickToastService.showSuccess("Invoices deleted");
                break;
            case 5:
                this.batchInvoiceStatusId = null;
                const result = await this.invoiceStatusSelector.confirm();
                if (result === SlickConfirmDialogResults.Ok) {
                    this.slickScreenBlockerService.block();
                    const success = await this.invoicesService.changeBatchInvoiceStatuses(batchInvoiceIds, this.batchInvoiceStatusId)
                    this.slickScreenBlockerService.unblock();
                    if (success)
                        this.slickToastService.showSuccess("Invoices updated");
                    else
                        this.slickToastService.showDanger("Error updating invoices")
                    this.updateGrid();
                }
        }
        this.gridModelsForBatch.forEach(x => {
            x.batch = false;
        });
        this.gridModelsForBatch = [];
    }

    onBatchInvoiceStatusSelect(statusDropdown: IDropdownModel) {
        this.batchInvoiceStatusId = statusDropdown.id;
    }

    async onRowClicked(invoiceGridModel: IInvoiceGridModel) {
        try {
            await this.functionLockService.lock("GET_INVOICE");
            // The full invoice is fetched before anything reacts to the click, so this is the only
            // feedback the user gets until the detail (or the customer page's dialog) appears
            this.slickScreenBlockerService.block();
            this.selectedInvoice = await this.invoicesService.getInvoice(invoiceGridModel.invoiceId);
            this.onInvoiceSelected.emit(this.selectedInvoice);
        }
        finally {
            this.slickScreenBlockerService.unblock();
            this.functionLockService.release("GET_INVOICE");
        }
    }
    async onRowContextMenu(contextMenuData) {
        (<MouseEvent>contextMenuData.mouseEvent).preventDefault();
        this.contextMenuData = contextMenuData;

        this.invoicesGridContextMenuRef.showContextMenu(contextMenuData.mouseEvent);
    }

    async contextMenuDeleteInvoice() {
        const invoiceGridModel: IInvoiceGridModel = this.invoicesGrid.visibleData[this.contextMenuData.rowIdx];
        const confirmResult = await this.deleteInvoiceConfirmRef.confirm();

        if (confirmResult === SlickConfirmDialogResults.Ok) {
            await this.invoicesService.deleteInvoice(invoiceGridModel.invoiceId);

            this.invoicesGrid.visibleData = this.invoicesGrid.visibleData.filter(x => x.invoiceId !== invoiceGridModel.invoiceId);
            if (this.selectedInvoice?.invoiceId === invoiceGridModel.invoiceId) {
                this.selectedInvoice = null;
                this.invoicesGrid.unselectRow();
                this.onInvoiceSelected.emit(null);
            }

            this.slickToastService.showSuccess(this.showInactiveOnly ? "Invoice set active" : "Invoice set inactive", 1000);
        }
    }

    async syncToQuickbooks(invoiceGridModel: IInvoiceGridModel) {

        if (invoiceGridModel.quickbooksSyncStatus === "Synced")
            return;
        if (invoiceGridModel.quickbooksSyncStatus === "Not Synced") {
            await this.invoicesService.syncQuickbooks(invoiceGridModel.invoiceId);
            invoiceGridModel.quickbooksSyncStatus = "Syncing";
            this.slickToastService.showSuccess(`Invoice ${invoiceGridModel.invoiceNumber} syncing to quickbooks`);
        }
        else {
            await this.invoicesService.syncQuickbooks(invoiceGridModel.invoiceId);
            invoiceGridModel.quickbooksSyncStatus = "Not Synced";
            this.slickToastService.showSuccess(`Invoice ${invoiceGridModel.invoiceNumber} unsynced from quickbooks`);
        }
    }

    async syncToBusinessCentral(invoiceGridModel: IInvoiceGridModel) {

        if (invoiceGridModel.businessCentralSyncStatus === "Synced")
            return;
        if (invoiceGridModel.businessCentralSyncStatus === "Not Synced") {
            await this.invoicesService.syncBusinessCentral(invoiceGridModel.invoiceId);
            invoiceGridModel.businessCentralSyncStatus = "Syncing";
            this.slickToastService.showSuccess(`Invoice ${invoiceGridModel.invoiceNumber} syncing to business central`);
        }
        else {
            await this.invoicesService.syncBusinessCentral(invoiceGridModel.invoiceId);
            invoiceGridModel.businessCentralSyncStatus = "Not Synced";
            this.slickToastService.showSuccess(`Invoice ${invoiceGridModel.invoiceNumber} unsynced from business central`);
        }
    }

    async onSearch(searchText: string) {
        this.searchText = searchText;
        this.updateGrid();
    }

    async onShowDealersOnlyChanged() {
        this.showDealersOnly = !this.showDealersOnly;

        localStorage.setItem("INVOICE_SHOW_DEALERS_ONLY", this.showDealersOnly.toString());
        this.updateGrid();
    }

    async onShowInternalSalesChanged() {
        this.showInternalSales = !this.showInternalSales;

        localStorage.setItem("INVOICE_SHOW_INTERNAL_SALES", this.showInternalSales.toString());
        this.updateGrid();
    }

    onInvoiceStatusChanged(invoiceStatus: IDropdownModel) {
        if (!invoiceStatus || invoiceStatus.id === this.selectedInvoiceStatus)
            return;

        localStorage.setItem("SELECTED_INVOICE_STATUS", invoiceStatus.id.toString());
        this.selectedInvoiceStatus = invoiceStatus.id;

        this.updateGrid();
    }

    onInvoiceMonthsChanged(invoiceMonth: IDropdownModel) {
        if (!invoiceMonth || invoiceMonth.id === this.selectedInvoiceMonths)
            return;

        localStorage.setItem("SELECTED_INVOICE_MONTHS", invoiceMonth.id.toString());
        this.selectedInvoiceMonths = invoiceMonth.id;

        this.updateGrid();
    }

    onSalesRepChanged(salesRep: IDropdownModel) {
        this.selectedSalesRepUserId = salesRep ? salesRep.id : null;
        this.updateGrid();
    }

    onArRepChanged(arRep: IDropdownModel) {
        this.selectedArRepId = arRep ? arRep.id : null;
        this.updateGrid();
    }

    async onNewInvoice() {
        this.selectedInvoice = new InvoiceModel();
        this.selectedInvoice.isQuote = false;
        this.selectedInvoice.isSalesOrder = false;
        this.selectedInvoice.quoteDate = moment().startOf("day").toDate();
        this.selectedInvoice.invoiceDate = moment().startOf("day").toDate();
        this.selectedInvoice.invoiceNumber = await this.invoicesService.getNextInvoiceNumber();
        this.selectedInvoice.createdBy = GlobalsService.userInfo.userId;
        this.onInvoiceSelected.emit(this.selectedInvoice);
    }

    async updateGrid() {
        try {
            await this.functionLockService.lock("UPDATE_GRID");
            this.selectedInvoice = null;
            this.onInvoiceSelected.emit(this.selectedInvoice);
            this.invoicesGrid?.unselectRow();
            this.slickScreenBlockerService.block(500);

            
            const params = {
                invoiceStatusId: this.selectedInvoiceStatus,
                invoiceMonths: this.selectedInvoiceMonths,
                searchString: this.searchText,
                filteredLocationIds: JSON.stringify(this.filteredLocationIds),
                showNotSyncedToQuickbooks: this.showNotSyncedToQuickbooks,
                showNotSyncedToBusinessCentral: this.showNotSyncedToBusinessCentral,
                showJobComplete: this.showInvoicesWhereJobIsComplete,
                showShipped: this.showInvoicesWhereOrderHasShipped,
                showDealersOnly: this.showDealersOnly,
                showInternalSales: this.showInternalSales,
                showPOSOnly: this.showPOSOnly,
                customerId: this.customerId,
                salesRepUserId: this.selectedSalesRepUserId,
                arRepId: this.selectedArRepId,
                showInactiveOnly: this.showInactiveOnly
            }
            

            await this.invoicesGrid.reloadGrid(params);
            if (this.autoSelectFirstRow && this.invoicesGrid.getVisibleRecords().length > 0)
                this.invoicesGrid.selectRow(0);
        }
        finally {
            this.slickScreenBlockerService.unblock();
            await this.functionLockService.release("UPDATE_GRID");
        }
    }

    async onLocationsChanged(selectedLocationsIds: number[]) {
        this.filteredLocationIds = selectedLocationsIds;
        await this.updateGrid();
    }

    async onShowNotSyncedToQuickbooksClicked() {
        this.showNotSyncedToQuickbooks = !this.showNotSyncedToQuickbooks;
        localStorage.setItem("INVOICES_SHOW_NOT_SYNCED_TO_QUICKBOOKS", this.showNotSyncedToQuickbooks.toString().toLowerCase());

        await this.updateGrid();
    }

    async onShowNotSyncedToBusinessCentralClicked() {
        this.showNotSyncedToBusinessCentral = !this.showNotSyncedToBusinessCentral;
        localStorage.setItem("INVOICES_SHOW_NOT_SYNCED_TO_BUSINESS_CENTRAL", this.showNotSyncedToBusinessCentral.toString().toLowerCase());

        await this.updateGrid();
    }

    async onShowInvoicesWhereJobIsCompleteClicked() {
        this.showInvoicesWhereJobIsComplete = !this.showInvoicesWhereJobIsComplete;
        localStorage.setItem("INVOICES_SHOW_INVOICES_WHERE_JOB_IS_COMPLETE", this.showInvoicesWhereJobIsComplete.toString().toLowerCase());

        await this.updateGrid();
    }

    async onShowInvoicesWhereOrderHasShippedClicked() {
        this.showInvoicesWhereOrderHasShipped = !this.showInvoicesWhereOrderHasShipped;
        localStorage.setItem("INVOICES_SHOW_INVOICES_WHERE_ORDER_HAS_SHIPPED", this.showInvoicesWhereOrderHasShipped.toString().toLowerCase());

        await this.updateGrid();
    }

    async onShowPOSOnlyClicked() {
        this.showPOSOnly = !this.showPOSOnly;
        localStorage.setItem("INVOICES_SHOW_POS_ONLY", this.showPOSOnly.toString().toLowerCase());

        await this.updateGrid();
    }

    async refreshRow(invoiceModel: IInvoiceModel) {
        // See if this got moved to invoice or sales order
        if (invoiceModel.isSalesOrder == true) {
            this.invoicesGrid.visibleData = this.invoicesGrid.visibleData.filter(x => x.invoiceId !== invoiceModel.invoiceId);
            this.selectedInvoice = null;
            this.invoicesGrid.unselectRow();
            return;
        }

        const invoiceGridModel = await this.invoicesService.getInvoiceForGridView(invoiceModel.invoiceId);

        const existingInvoiceIdx = this.invoicesGrid.visibleData.findIndex(x => x.invoiceId === invoiceModel.invoiceId);
        if (existingInvoiceIdx >= 0)
            this.invoicesGrid.updateRecord(existingInvoiceIdx, invoiceGridModel);
        else
            this.invoicesGrid.addNewRecord(invoiceGridModel);

    }

    exportToCSV() {
        window.location.href = `${GlobalsService.apiUrl}/reporting/exportInvoicesToCSV?cid=${GlobalsService.company.companyId}&filteredLocationIds=${JSON.stringify(this.filteredLocationIds)}&selectedInvoiceStatus=${this.selectedInvoiceStatus}&showNotSynced=${this.showNotSyncedToQuickbooks}&showJobComplete=${this.showInvoicesWhereJobIsComplete}&showShipped=${this.showInvoicesWhereOrderHasShipped}&searchString=${this.searchText}`;
    }

    findInvoice(invoice: IInvoiceModel) {
        const idx = this.invoicesGrid.visibleData.findIndex(x => x.invoiceId === invoice.invoiceId);
        if (idx >= 0) {
            this.invoicesGrid.selectRow(idx);
        }
        this.selectedInvoice = invoice;
    }
}
